import React from "react";
import { Redirect } from "react-router-dom";
import Login from "./Authentication/login";
import ForgotPassword from "./Authentication/forgotpassword";
import Maintenance from "./Authentication/maintenance";
import UserList from "./Pages/User/list";
import UserDetails from "./Pages/User/details";
import OpinionList from "./Pages/Opinion/list";
import OpinionDetails from "./Pages/Opinion/details";
import CommentList from "./Pages/Comment/list";
import AgoraList from "./Pages/Agora/list";
import AgoraOpinions from "./Pages/Agora/opinion";
import OpinionMembre from "./Pages/Agora/membre";
import Profile from "./Pages/profile";
import ModerateurList from "./Pages/Moderateur/list";
import ModerateurDetails from "./Pages/Moderateur/details";
import RoleList from "./Pages/Role/list";
import ReportList from "./Pages/Report/list";
import ReferralList from "./Pages/Referral/list";
import AwardList from "./Pages/Award/list";
import VerificationDemandList from "./Pages/VerificationDemand/list";
import VerificationDemandDetails from "./Pages/VerificationDemand/details";
import StatsPage from "./Pages/Stats/StatsPage";
import ManualWithdrawal from "./Pages/Payment/manualWithdrawal";
import SubscriptionList from "./Pages/Subscription/list";
import Dashboard from "./Pages/dashboard";
import Authorization from "./Pages/Authorization/list";
import AuthorizationRequestList from "./Pages/Authorization/request";
import HolidayBalanceList from "./Pages/HolidayBalance/list";
import Hub from "./Pages/hub";
import Setting from "./Pages/Setting";
import EventList from "./Pages/Event/list";
import Logs from "./Pages/logs";
import ListLive from "./Pages/Live/list";
import Challenge from "./Pages/Challenge/Challenge";
import PaymentList from "./Pages/Payment/list";
import PaymentStatistics from "./Pages/Payment/statistics";
import PaymentDetails from "./Pages/Payment/details";
import PaymentCashout from "./Pages/Payment/cashout";
import Wallets from "./Pages/Wallets/list";
import WalletDetails from "./Pages/Wallets/details";
import PaymentMethods from "./Pages/PaymentMethod/list";
import PaymentMethodDetails from "./Pages/PaymentMethod/details";
import PaymentCountries from "./Pages/PaymentCountries/list";
import PaymentCountryMethodActivation from "./Pages/PaymentCountries/methodActivation";
import PaymentCountryMethods from "./Pages/PaymentCountries/methods";
import PaymentSettingsHub from "./Pages/PaymentSettings/Hub";
import PaymentProvidersList from "./Pages/PaymentProviders/list";

const Routes = [
  {
    path: "/",
    name: "dashboard",
    exact: true,
    pageTitle: "Tableau de bord",
    component: Dashboard,
  },
  {
    path: "/authorizations",
    name: "authorizations",
    exact: true,
    pageTitle: "Authorizations",
    component: Authorization,
  },
  {
    path: "/authorization-requests",
    name: "authorization-requests",
    exact: true,
    pageTitle: "Authorization requests",
    component: AuthorizationRequestList,
  },
  {
    path: "/users",
    name: "users",
    exact: true,
    pageTitle: "Users",
    component: UserList,
  },
  {
    path: "/lives",
    name: "lives",
    exact: true,
    pageTitle: "Lives",
    component: ListLive,
  },
  {
    path: "/users/:id",
    name: "user.details",
    exact: true,
    pageTitle: "Details",
    component: UserDetails,
  },
  {
    path: "/users/:id/opinions",
    name: "user.opinions",
    exact: true,
    pageTitle: "Opinions",
    component: UserDetails,
  },
  {
    path: "/users/:id/agoras",
    name: "user.agoras",
    exact: true,
    pageTitle: "Agoras",
    component: UserDetails,
  },
  {
    path: "/users/:id/comments",
    name: "user.comments",
    exact: true,
    pageTitle: "Comments",
    component: UserDetails,
  },
  {
    path: "/users/:id/followers",
    name: "user.followers",
    exact: true,
    pageTitle: "Followers",
    component: UserDetails,
  },
  {
    path: "/users/:id/subscriptions",
    name: "user.subscriptions",
    exact: true,
    pageTitle: "Subscriptions",
    component: UserDetails,
  },
  {
    path: "/users/:id/friends",
    name: "user.friends",
    exact: true,
    pageTitle: "Friends",
    component: UserDetails,
  },
  {
    path: "/challenges",
    name: "challenges",
    exact: true,
    pageTitle: "Challenge",
    component: Challenge,
  },
  {
    path: "/opinions",
    name: "opinions",
    exact: true,
    pageTitle: "Opinions",
    component: OpinionList,
  },
  {
    path: "/opinions/:id",
    name: "opinions.details",
    exact: true,
    pageTitle: "Opinions",
    component: OpinionDetails,
  },
  {
    path: "/comments",
    name: "comments",
    exact: true,
    pageTitle: "Commentaires",
    component: CommentList,
  },
  {
    path: "/agoras",
    name: "agoras",
    exact: true,
    pageTitle: "Agoras",
    component: AgoraList,
  },
  {
    path: "/agoras/:id/opinions",
    name: "agoras.opinions",
    exact: true,
    pageTitle: "Agoras",
    component: AgoraOpinions,
  },
  {
    path: "/agoras/:id/members",
    name: "agoras.members",
    exact: true,
    pageTitle: "Agoras",
    component: OpinionMembre,
  },
  {
    path: "/referrals",
    name: "referrals",
    exact: true,
    pageTitle: "Referral",
    component: ReferralList,
  },
  {
    path: "/reports",
    name: "reports",
    exact: true,
    pageTitle: "Report",
    component: ReportList,
  },
  {
    path: "/verifications",
    name: "verifications",
    exact: true,
    pageTitle: "Verification",
    component: VerificationDemandList,
  },
  {
    path: "/stats/users-active",
    name: "user-active-stats-legacy",
    exact: true,
    pageTitle: "Statistics",
    component: () => <Redirect to="/stats/users" />,
  },
  {
    path: "/stats/users-badges",
    name: "user-badge-stats-legacy",
    exact: true,
    pageTitle: "Statistics",
    component: () => <Redirect to="/stats/badges" />,
  },
  {
    path: "/stats/:tab?",
    name: "stats",
    exact: true,
    pageTitle: "Statistics",
    component: StatsPage,
  },

  {
    path: "/verifications/:id/details",
    name: "verifications.details",
    exact: true,
    pageTitle: "Verification",
    component: VerificationDemandDetails,
  },
  {
    path: "/awards",
    name: "awards",
    exact: true,
    pageTitle: "Awards",
    component: AwardList,
  },
  {
    path: "/subscriptions",
    name: "subscriptions",
    exact: true,
    pageTitle: "Subscriptions",
    component: SubscriptionList,
  },
  {
    path: "/login",
    name: "login",
    exact: true,
    pageTitle: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "profile",
    exact: true,
    pageTitle: "Profile",
    component: Profile,
  },
  {
    path: "/moderateurs",
    name: "admins",
    exact: true,
    pageTitle: "Admin",
    component: ModerateurList,
  },
  {
    path: "/moderateurs/:email",
    name: "admin.details",
    exact: true,
    pageTitle: "Admin",
    component: ModerateurDetails,
  },
  {
    path: "/roles",
    name: "roles",
    exact: true,
    pageTitle: "Rôles",
    component: RoleList,
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    exact: true,
    pageTitle: "Tables",
    component: ForgotPassword,
  },
  {
    path: "/maintenance",
    name: "maintenance",
    exact: true,
    pageTitle: "Maintenance",
    component: Maintenance,
  },
  {
    path: "/hr/holidays_balance",
    name: "holidays_balance",
    exact: true,
    pageTitle: "Soldes de conges",
    component: HolidayBalanceList,
  },
  {
    path: "/hubs",
    name: "hub",
    exact: true,
    pageTitle: "Hub",
    component: Hub,
  },
  {
    path: "/payment-settings",
    name: "payment-settings",
    exact: true,
    pageTitle: "Paramètres de paiement",
    component: PaymentSettingsHub,
  },
  {
    path: "/payment-providers",
    name: "payment-providers",
    exact: true,
    pageTitle: "Providers de paiement",
    component: PaymentProvidersList,
  },
  {
    path: "/payments/manual-withdrawal",
    name: "manual-withdrawal",
    exact: true,
    pageTitle: "Manual withdrawal",
    component: ManualWithdrawal,
  },
  {
    path: "/payments/statistics",
    name: "payment-statistics",
    exact: true,
    pageTitle: "Statistique des retraits",
    component: PaymentStatistics,
  },
  {
    path: "/payments/cashout",
    name: "payment-cashout",
    exact: true,
    pageTitle: "Liste des cashouts",
    component: PaymentCashout,
  },
  {
    path: "/payments",
    name: "payments",
    exact: true,
    pageTitle: "Liste des transactions",
    component: PaymentList,
  },
  {
    path: "/payments/:id",
    name: "payment.details",
    exact: true,
    pageTitle: "Détails de la tansaction",
    component: PaymentDetails,
  },
  {
    path: "/wallets",
    name: "wallets.list",
    exact: true,
    pageTitle: "liste des portefeuilles",
    component: Wallets,
  },
  {
    path: "/payment-methods",
    name: "methods",
    exact: true,
    pageTitle: "Méthode de paiement",
    component: PaymentMethods,
  },
  {
    path: "/payment-countries",
    name: "countries",
    exact: true,
    pageTitle: "Liste des pays de paiement",
    component: PaymentCountries,
  },
  {
    path: "/payment-countries/:id/methods/activation",
    name: "countries.methods-activation",
    exact: true,
    pageTitle: "Activer des méthodes de paiement",
    component: PaymentCountryMethodActivation,
  },
  {
    path: "/payment-countries/:id/methods/:methodId",
    name: "countries.methods.details",
    exact: true,
    pageTitle: "Frais — méthode de paiement",
    component: PaymentMethodDetails,
  },
  {
    path: "/payment-countries/:id/methods",
    name: "countries.methods",
    exact: true,
    pageTitle: "Gestion des méthodes",
    component: PaymentCountryMethods,
  },
  {
    path: "/payment-methods/:id",
    name: "methods.details",
    exact: true,
    pageTitle: "Frais — méthode de paiement",
    component: PaymentMethodDetails,
  },
  {
    path: "/wallets/:id",
    name: "wallets.details",
    exact: true,
    pageTitle: "liste des portefeuilles",
    component: WalletDetails,
  },
  {
    path: "/settings",
    name: "settings",
    exact: true,
    pageTitle: "Settings",
    component: Setting,
  },
  {
    path: "/events",
    name: "events",
    exact: true,
    pageTitle: "Events",
    component: EventList,
  },
  {
    path: "/logs",
    name: "logs",
    exact: true,
    pageTitle: "Logs",
    component: Logs,
  },
];

export default Routes;
